import { Component, inject } from '@angular/core';
import { MatDivider } from '@angular/material/divider';
import { TranslatePipe } from '@ngx-translate/core';

import { FnWrapperPipe } from '@celum/ng2base';
import { Account } from '@celum/sacc/domain';

import { AdminService } from '../../services/admin/admin.service';
import { hasContentCustomSpecificationLicense } from '../../util/organization.util';

@Component({
  selector: 'organization-badge',
  templateUrl: './organization-badge.component.html',
  styleUrl: './organization-badge.component.scss',
  imports: [MatDivider, TranslatePipe, FnWrapperPipe]
})
export class OrganizationBadgeComponent {
  protected adminService = inject(AdminService);

  protected hasContentCustomLicence(account: Account): boolean {
    return hasContentCustomSpecificationLicense(account);
  }
}
